<div class="modal-header">
  <h4 class="modal-title"
      [innerHtml]="('ADD_DEVICE'|translate)"></h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close(generateLocationPreference)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="filter-for-list">
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput [value]="devices ? devices.filter : null" (keyup)="applyFilter($event.target.value)"
           [placeholder]="'SEARCH' | translate">
  </mat-form-field>

  <div class="deviceTypeFilter">
    <app-device-type-selector [deviceTypeSelected]="deviceTypeSelected" [deviceTypeFilterForChips]="[8,11,18]"
                              (deviceTypeChanged)="filterListByDeviceType($event)"></app-device-type-selector>
  </div>

  <div class="deviceAssignementInfos warning-device-type" *ngIf="deviceTypeSelected === 0">Please select a device
    type
  </div>
  <div class="deviceAssignementInfos" *ngIf="deviceTypeSelected !== 0">
    <div>
      <mat-form-field>
        <input matInput [placeholder]="'NAME'|translate" [(ngModel)]="deviceAssignementName" required
               type="text">
      </mat-form-field>
      <mat-form-field style="margin-left:10px;" *ngIf="deviceTypeSelected == 11 || deviceTypeSelected == 18">
        <input matInput placeholder="Dyn DNS" [(ngModel)]="deviceAssignementDyndns" type="url">
      </mat-form-field>
    </div>
    <div *ngIf="deviceTypeSelected === 11 || deviceTypeSelected == 18">
      <app-location-assignment-preferences-toggle
        [checked]="generateLocationPreference"
        (change)="generateLocationPreference = $event">
      </app-location-assignment-preferences-toggle>
    </div>
  </div>

  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>

<table mat-table [dataSource]="devices" matSort class="table-striped" style="width:100%">

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
    <td mat-cell *matCellDef="let device"> {{device.id}}</td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE'|translate}}</th>
    <td mat-cell *matCellDef="let device">
      <mat-chip-list>
        <mat-chip>
          {{device.device_type | translate}}

        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>
  <ng-container matColumnDef="uid">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'UID'|translate}}</th>
    <td mat-cell *matCellDef="let device"><b>{{device.uid}}</b>
      <mat-icon style="color:orange;cursor:pointer"
                (click)="useUidAsName(device.uid)"
                matTooltipPosition="right"
                [matTooltip]="'USE_UID_AS_NAME_TOOLTIP'|translate">near_me
      </mat-icon>
    </td>
  </ng-container>


  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let device">


      <mat-icon *ngIf="deviceAssignementName.length >3" style="color:green;cursor:pointer"
                (click)="postProjectDeviceAssignement(device.id)"
                matTooltipPosition="right"
                [matTooltip]="'CREATE_ICON_TOOLTIP'|translate">check_circle
      </mat-icon>

      <mat-icon *ngIf="deviceAssignementName.length <= 3" style="color:#cccccc;cursor:pointer"
                (click)="postProjectDeviceAssignement(device.id)"
                matTooltipPosition="right"
                [matTooltip]="'CREATE_ICON_TOOLTIP'|translate">check_circle
      </mat-icon>

    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons [pageSize]="5"></mat-paginator>


<div class="modal-footer">

  <button type="button" class="btn btn-light" (click)="activeModal.close(generateLocationPreference)"
          [innerHTML]="'CLOSE' | translate">Close
  </button>
</div>
